/**
 * Shopify's #shopify-pc__banner does not persist Accept on 127.0.0.1 theme
 * preview (storefront-banner.js only treats "localhost" as HTTP). Remember
 * the choice for this tab session so the bar does not return on every click.
 */
(function rememberCookieBanner() {
  const KEY = 'amadaPcBanner';
  const BANNER = '#shopify-pc__banner, [id^="shopify-pc"]';

  function hideBanner() {
    document.querySelectorAll(BANNER).forEach((el) => {
      el.style.setProperty('display', 'none', 'important');
    });
  }

  function remember() {
    try {
      sessionStorage.setItem(KEY, '1');
    } catch (error) {
      /* private mode */
    }
    hideBanner();
  }

  function seen() {
    try {
      return sessionStorage.getItem(KEY) === '1';
    } catch (error) {
      return false;
    }
  }

  if (seen()) {
    hideBanner();
    const root = document.documentElement;
    const observer = new MutationObserver(() => {
      if (document.querySelector('#shopify-pc__banner, [id^="shopify-pc"]')) hideBanner();
    });
    observer.observe(root, { childList: true, subtree: true });
  }

  document.addEventListener('visitorConsentCollected', remember);

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('button, [role="button"], a');
      if (!button) return;
      const banner = button.closest('#shopify-pc__banner, [id^="shopify-pc"]');
      if (!banner) return;
      const label = (button.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (label === 'accept' || label === 'decline') remember();
    },
    true
  );
})();
